import application_settings from '../applicationSettings'
import Event from './Event'

class EmailVerification extends Event {
    eventName = 'oms_emailVerification';

    constructor() {
        super();
        this.add();
    }

/** 
 * 
 * 
 * 
*/
    eventFunction(data) {


 
        let requestId = (data.request_id) ? data.request_id : '';
        let thisObj = this;
         let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.EmailVerification;
        data.method = 'POST';
        data.data = {
            request_id: data.otp_request_id,
            otp: data.otp ? data.otp : null,
            client_id:data.client_id,
   
        };

        // send request
        this.sendRequest(data, function (response) {
        
          if (response) {
           
            //format response data
            let data = thisObj.formatResponseData(response);
     

            //fire success event
            thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
          }
        });

    }



}

export default EmailVerification;